//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ALL_TABLES_OPTION, textsDefaul } from '@/js/constants';
import businessTermService from '@/apps/data-platform/services/master_data/business_term_service';
import PaginationVue from '@/components/PaginationVue.vue';
import StateComponent from '@/components/StateComponent.vue';
export default {
  name: 'ContMyBusinessTermsComponent',
  components: {
    PaginationVue: PaginationVue,
    StateComponent: StateComponent
  },
  props: {
    placeholder: {
      type: String,
      required: false,
      default: 'Search by business term ...'
    },
    showDomains: {
      type: Boolean,
      required: false,
      default: true
    },
    filter_enabled: {
      type: Boolean
    }
  },
  data: function data() {
    return {
      collapse_filter: false,
      messageEmptyList: textsDefaul.LOADING,
      query: '',
      showOptions: false,
      select_domain: null,
      list_env: [{
        value: null,
        text: 'All'
      }, {
        value: 'dev',
        text: 'Development'
      }, {
        value: 'test',
        text: 'Test'
      }],
      criteria: {
        name: '',
        path_name: '',
        column_name: '',
        data_operator: '',
        env: null
      },
      items: [],
      pagination: {
        current: 1,
        limit: 10,
        total: 0,
        offset: 0
      }
    };
  },
  computed: {
    businessTermFields: function businessTermFields() {
      return [
      //{ key: '↕', variant: 'return-sort' },
      {
        text: this.traductor('my_objects.tablas_objects.bterm'),
        value: 'business_term',
        sortable: true,
        class: 'text-left font-weight-bold'
      }, {
        text: this.traductor('my_objects.tablas_objects.definition'),
        value: 'definition',
        sortable: true,
        class: 'text-left'
      }, {
        text: this.traductor('my_objects.tablas_objects.values'),
        value: 'values',
        sortable: true,
        class: 'h6',
        align: 'center'
      }, {
        text: this.traductor('my_objects.tablas_objects.creation_date'),
        value: 'update_date',
        sortable: true,
        align: 'center'
      }, {
        text: this.traductor('my_objects.tablas_objects.actions'),
        value: 'actions',
        class: ['pr-1', 'pl-1'],
        label: '',
        align: 'left'
      }];
    },
    get_list_domains: function get_list_domains() {
      var list_domains = [];
      if (this.showDomains) {
        list_domains = window.userInfo ? Object.values(window.userInfo.listOrgs) : [];
        list_domains.unshift(window.userInfo.domain);
        list_domains.unshift(ALL_TABLES_OPTION);
      } else {
        list_domains.unshift(window.userInfo.domain);
      }
      return list_domains;
    }
  },
  watch: {
    select_domain: function select_domain() {
      this.onBuscar();
    }
  },
  created: function created() {
    if (this.defaultDomain == null) {
      this.select_domain = window.userInfo ? window.userInfo.domain : null;
    } else {
      this.select_domain = this.defaultDomain;
    }
  },
  methods: {
    onSearch: function onSearch(filter) {
      this.query = filter.text_filter;
      if (this.select_domain != filter.choose_domain) {
        this.select_domain = filter.choose_domain;
      }
    },
    onCleanSearch: function onCleanSearch() {
      this.query = "";
      this.select_domain = window.userInfo.domain;
    },
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    onBuscar: function onBuscar() {
      var _this = this;
      console.log("Buscar");
      var params = {
        domain: this.select_domain,
        clauses: {
          accountable: window.userInfo.email
        }
      };
      businessTermService.getBusinessTerms(params).then(function (response) {
        if (response.data && response.data.result) {
          _this.items = response.data.result;
          _this.pagination.total = _this.items.length;
        } else {
          _this.messageEmptyList = textsDefaul.NOT_FOUND;
        }
      });
    },
    openBusinessTerm: function openBusinessTerm(item) {
      this.$router.push({
        path: "/BusinessTerm/".concat(this.select_domain, "/").concat(item.kbusiness_term)
      });
    }
  }
};